module.exports = __webpack_public_path__ + "media/packs/images/small-sea-6f0b8c8412c25c32c176bead3f1ca58c.svg";